import { Result, Button, Card } from "antd";

const CartransferPayF23Continue = ({
  cartransfer,
  newF23,
  confirmPayment,
  links,
  loading,
}) => {
  const goToPay = () => window.open(cartransfer.paymentUrl, "_blank");
  return (
    <Card title="Pago F23" style={{ margin: 10 }}>
      <Result
        status="info"
        title={`La transferencia con repertorio ${cartransfer.repertory} ya presenta un F23`}
        subTitle="Favor seleccione una acción a continuación"
        extra={[
          <Button type="primary" onClick={goToPay}>
            Ir al pago
          </Button>,
          <Button onClick={newF23}>Nuevo F23</Button>,
          Object.keys(links).length === 0 ? (
            <Button onClick={confirmPayment} loading={loading.movements}>
              Generar doctos F23
            </Button>
          ) : (
            <>
              <Button as="a" href={links.folder_movements} target="_blank">
                Cert movimientos
              </Button>
              <Button as="a" href={links.folder_f23_payment} target="_blank">
                Cert pago
              </Button>
            </>
          ),
        ]}
      />
    </Card>
  );
};

export default CartransferPayF23Continue;
